module.exports = __webpack_public_path__ + "static/media/footer-icon-x.14f1994f.svg";